import React from 'react'
import moment from 'moment'
import ConsumedFuelContent from '../components/ConsumedFuelContent'
import { Query } from 'react-apollo'
import { client } from '../graphql/client'
import { ASCENDING_EVENT_OF_CURRENT_DAY_BY_VEHICLE } from '../query/event'
import {
  SORT_METRIC_BY_VEHICLE_UPDATED,
  FIRST_METRIC_OF_DAY
} from '../query/metric'
import CircularProgress from '@material-ui/core/CircularProgress'
moment.locale('fr')

class ConsumedFuelComponent extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      data: this.dataMetrics(this.props.sort_metrics),
      d: new Date()
    }
  }

  componentDidMount () {
    const self = this
    let trbImm = self.props.trbImm
    var d = self.state.d
    this.props.subscribeToMore({
      document: SORT_METRIC_BY_VEHICLE_UPDATED,
      variables: {
        jsonFilter: {
          'trb_imm': trbImm
        }
      },
      updateQuery: (prev, {
        subscriptionData
      }) => {
        if (!subscriptionData.data) {
          return prev
        } else {
          this.setState({
            data: self.dataMetrics(subscriptionData.data.latest_metrics)
          })
          return {
            latest_metrics: subscriptionData.data.latest_metrics
          }
        }
      }
    })
    self.getFirstMetricOfDay(trbImm, d)
  }

  getFirstMetricOfDay (vehicleNumber, d) {
    const self = this
    client
      .query({
        query: FIRST_METRIC_OF_DAY,
        variables: { occurred_at: moment(d).format('YYYY-MM-DD'), jsonFilter: { 'trb_imm': vehicleNumber } }
      })
      .then(result => {
        let latestMetric = result.data.metrics
        self.setState({
          firstMetricOfDay: latestMetric
        })
      }).catch(error => console.log(error))
  }

  dataMetrics (metrics) {
    let dataFuel = []
    metrics.forEach(function (element, key) {
      let values = {}
      for (let tag in element) {
        if (tag === 'metadata') {
          for (let subTag in element[tag]) {
            values[subTag] = metrics[key][tag][subTag]
          }
        } else {
          values[tag] = element[tag]
        }
      }
      dataFuel.push(values)
    })
    return dataFuel
  }

  render () {
    let volume = this.state.data[0].value
    let d = this.state.d
    d.setHours(0, 0, 0, 0)
    var firstMetricOfDay = this.state.firstMetricOfDay
    if (!firstMetricOfDay) {
      return <CircularProgress style={{ color: '#7ED321', marginTop: '50px' }} color='inherit' />
    }
    return (
      <div>
        <Query
          query={ASCENDING_EVENT_OF_CURRENT_DAY_BY_VEHICLE}
          variables={{ occurred_at: d, jsonFilter: { 'trb_imm': this.props.trbImm } }}
        >
          {({ data, loading, error, subscribeToMore }) => {
            if (!data) {
              return null
            }
            if (error) {
              return <p>{error.message}</p>
            }

            if (loading) {
              return <CircularProgress style={{ color: '#7ED321', marginTop: '50px' }} color='inherit' />
            }

            return (
              <ConsumedFuelContent
                currentVolume={volume}
                firstMetricOfDay={firstMetricOfDay}
                events={data.events}
                vehicleNumber={this.props.trbImm}
                subscribeToMore={subscribeToMore}
              />
            )
          }}
        </Query>
      </div>
    )
  }
}

export default ConsumedFuelComponent
